








































































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { LoanQualifier, LoanQualifierType, LoanQualifierProduct } from '@/api/product/levelrewards/qualifiers';
import {
  ProductTypeMap, ProductTypeDetails,
} from '@/api/producttypes';
import {
  AccountProductTypeMap,
} from '@/api/accountproducttypes';
import {
  ProductMapping,
} from '@/api/productmapping';
import { ValidationTool } from '@/util';

enum IncludeType { ALL, TYPES, PRODUCTS }

@Component
export default class LoanQualifierEditor extends Vue {
  @Prop()
  value!:LoanQualifier;

  @Prop()
  productTypes!: ProductTypeMap;

  @Prop()
  productMappings!: ProductMapping[];

  @Prop()
  accountProductTypes!: AccountProductTypeMap;

  includeTypeItems:any = [{ text: 'All loans', value: IncludeType.ALL }, { text: 'Specific types', value: IncludeType.TYPES }, { text: 'Specific products', value: IncludeType.PRODUCTS }]

  includeType: IncludeType = IncludeType.ALL;

  workingQualifier:LoanQualifier | null = null;

  selectedProductTypes: string[] = [];

  selectedExternalProductMappingIds: number[] = [];

  selectableProductTypes: ProductTypeDetails[] = [];

  selectableProductMappings: ProductMapping[] = [];

  // Make available to template
  IncludeType:any = IncludeType;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  // This rule always fails, but is only applied to the "count of loans" control when there are no loan products.
  // Implemented this way as the rule doesn't have access to members of the enclosing view to do the check
  // itself.
  noProductsRule:Array<any> = [(value: any) => 'No loans configured!'];

  mounted() {
    this.populateLists();
    this.initializeQualifier();
  }

  populateLists() {
    this.selectableProductTypes = [];
    this.selectableProductMappings = [];

    const loanTypes:string[] = this.accountProductTypes.LOAN;

    loanTypes.forEach((typeName:string) => {
      if (typeName !== 'NEEDS_MAPPING') {
        this.selectableProductTypes.push(this.productTypes[typeName]);
      }
    });

    this.productMappings.forEach((productMapping:ProductMapping) => {
      if (productMapping.accountType === 'LOAN') {
        this.selectableProductMappings.push(productMapping);
      }
    });
  }

  @Watch('includeType')
  onNewIncludeType() {
    if (this.includeType !== IncludeType.TYPES) {
      this.workingQualifier!.loanTypes = [];
      this.selectedProductTypes = [];
    }

    if (this.includeType !== IncludeType.PRODUCTS) {
      this.workingQualifier!.loanProducts = [];
      this.selectedExternalProductMappingIds = [];
    }
    this.onChange();
  }

  @Watch('value')
  initializeQualifier() {
    this.workingQualifier = this.value.clone() as LoanQualifier;

    this.selectedProductTypes = [];
    this.selectedExternalProductMappingIds = [];

    if (this.workingQualifier.loanTypes && this.workingQualifier.loanTypes.length > 0) {
      this.includeType = IncludeType.TYPES;
      this.workingQualifier.loanTypes.forEach((loanQualifierType: LoanQualifierType) => {
        this.selectedProductTypes.push(loanQualifierType.productType);
      });
    } else if (this.workingQualifier.loanProducts && this.workingQualifier.loanProducts.length > 0) {
      this.includeType = IncludeType.PRODUCTS;
      this.workingQualifier.loanProducts.forEach((loanQualifierProduct: LoanQualifierProduct) => {
        this.selectedExternalProductMappingIds.push(loanQualifierProduct.externalProductMappingId);
      });
    }
  }

  onChange() {
    this.$emit('input', this.workingQualifier);
  }

  onSelectedProductTypesChange() {
    this.workingQualifier!.loanTypes = [];

    this.selectedProductTypes.forEach((productType: string) => {
      this.workingQualifier!.loanTypes.push({
        id: null,
        productType,
      });
    });
    this.onChange();
  }

  onSelectedProductsChange() {
    this.workingQualifier!.loanProducts = [];

    this.selectedExternalProductMappingIds.forEach((externalProductMappingId: number) => {
      this.workingQualifier!.loanProducts.push({
        id: null,
        externalProductMappingId,
      });
    });
    this.onChange();
  }
}
